import { createMofaConfig } from "./create-mofa-config";

export const defaultAppConfig = {
  appsUMD: '/assets/battery-label/battery-label-umd.js',
  appsCommonsJS: '/assets/battery-label/battery-label-commonjs.js',
  appContent: null,
  createFunctionInstance: createMofaConfig,
};
